import { ItemSplitKindEnum } from "@finway-group/shared/lib/models/expense/expenseSplit.model"
import { getExpenseFieldsSummaryBasedOnSplits } from "~Shared/utils/expense.utils"
import { type UpdatedOcrObject } from "~Shared/utils/ocr.utils.types"

/**
 * Reimbursement ITEM UI only shows header CC fields; if OCR only returns CC on splits, derive header CC when uniform.
 * For hospitality, TIP item splits are excluded so they do not break uniformity of cost centers on remaining lines.
 */
export const mergeHeaderCostCentersFromOcrSplits = (updateData: UpdatedOcrObject, options: { isHospitality?: boolean; taxRateId?: string }): UpdatedOcrObject => {
    const { isHospitality, taxRateId } = options
    const splitsForHeaderSummary =
        isHospitality && updateData.splits?.length ? updateData.splits.filter((s) => !("kind" in s) || s.kind !== ItemSplitKindEnum.TIP) : updateData.splits
    const allocationSummary = splitsForHeaderSummary?.length ? getExpenseFieldsSummaryBasedOnSplits(splitsForHeaderSummary, taxRateId, false) : {}
    return {
        ...updateData,
        ...(updateData.costCenter === undefined && allocationSummary.costCenter !== undefined && { costCenter: allocationSummary.costCenter }),
        ...(updateData.costCenter2 === undefined && allocationSummary.costCenter2 !== undefined && { costCenter2: allocationSummary.costCenter2 }),
    }
}
